










































































































































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import _com from "@/assets/js/common";
import {getPreciseDayInterval} from "@/assets/js/utils";
import cookie from "@/assets/js/cookie"
import positionLost from "./positionLost.vue";
import couponItem from "./couponItem.vue";
import { formatDate } from "@/assets/js/date";
@Component({
	computed: {

	},
	components: { positionLost, couponItem }
})
export default class goodsDetailModal extends Vue {
	bannerCurrent: any = 0
	detailTab: any = 1;
	browser = _com.browser();
	couponPrice:any = 0;
	get good() {
		let good = this.$store.getters["environment/getIsGoodsDetail"];
		return good;
	}
	get roomData() {//房间数据
		return this.$store.getters["getRoomDetail/getRoomDetail"];
	}
	isClick = true;
	prodItems = false;// 规格选择弹框
	get creatbanner() {
		if (this.goodsDetail.colors[this.active]) {
			return this.goodsDetail.colors[this.active].items[this.sizeActive].imageList || [];
		}
		return [];
	}
	get serviceUrl() {
		return `https://livechat${process.env.VUE_APP_URI_DOMAIN}/imweb/visitorBusinessMobile?channel=yxdsq&source=item&merchantId=${this.goodsDetail.merchantId}&storeId=${this.goodsDetail.uleStoreId}&itemId=${this.good.listId}`;
	}
	get cartNum() {// 购物车数量
		if (!this.prodItems) {
			console.log('222');
		}
		let cartData: any = localStorage.getItem('broadcast_cart') || null;
		if (cartData) {
			cartData = JSON.parse(cartData);
			let obj: any = {}
			if (cartData[this.roomData.roomNumber] && cartData[this.roomData.roomNumber].scene_number == this.roomData.scene_number) {
				obj = cartData[this.roomData.roomNumber]
			}
			let num = 0;
			for (const key in obj) {
				if (key != 'scene_number' && key != 'time') {
					const item = obj[key];
					num += item.itemData.itemCount;
				}
			}
			return num || null;
		}
		return null
	}
	get storage() {
		if (this.goodsDetail.colors[this.active]) {
			return this.goodsDetail.colors[this.active].items[this.sizeActive].itemStorage
		}
		return 0
	}
	get price() {
		if (this.goodsDetail.promotionIds && (this.goodsDetail.promotionIds.indexOf("6202") > -1 ||
			this.goodsDetail.promotionIds.indexOf("6203") > -1)
		) {
			//限时特价  新人礼特价
			return this.goodsDetail.colors[this.active].items[this.sizeActive].membershipPrice;
		} else if (this.goodsDetail.colors[this.active]) {
			return this.goodsDetail.colors[this.active].items[this.sizeActive].itemSalPrice;
		}
	}
	get subList() {
		return `${this.goodsDetail.colors[this.active].items[this.sizeActive].itemId}:${this.good.listId}:${this.prodCount}:${this.price}`;
	}
	goodsDetail: any = {
		colors: [],
	}
	goodsDesc: any = ''
	paramsDesc: any = []
	active = 0
	sizeActive = 0
	activeListingTag: any = ''
	oldCouObj: any = null
	coupons: any = []
	disabledCoupons: any = []
	allCoupons: any = []
	adCart() {
		if (this.isClick) {
			this.isClick = false;
		} else {
			return false;
		}
		let item = this.goodsDetail.colors[this.active].items[this.sizeActive]
		item.itemCount = this.prodCount
		item.checked = true
		item.colorName = this.goodsDetail.colors[this.active].colorName
		let obj: any = {}, cartObj: any = {}
		let cartData = localStorage.getItem('broadcast_cart') || null;
		if (cartData) {
			cartObj = JSON.parse(cartData)
		}
		if (cartObj[this.roomData.roomNumber]) {
			if (cartObj[this.roomData.roomNumber].scene_number == this.roomData.scene_number) {
				obj = cartObj[this.roomData.roomNumber]
			} else {
				obj = {}
			}
		}
		if (obj[item.itemId]) {
			this.$toast("购物车数量已更新");
		} else {
			this.$toast("商品已加入购物车");
		}
		obj[item.itemId] = this.goodsDetail
		obj[item.itemId].itemData = item
		obj.scene_number = this.roomData.scene_number
		obj.time = Date.now()
		cartObj[this.roomData.roomNumber] = obj
		localStorage.setItem('broadcast_cart', JSON.stringify(cartObj))
		setTimeout(() => {
			this.isClick = true;
			this.prodItems = false
		}, 1000)
	}
	isShowPosPop: boolean = false
	showCoupon() {
		this.showCouponList = true;
		setTimeout(() => {
			this.coupons.map((item: any, index: any) => {
				let coupon = document.querySelectorAll(".van-coupon")[index];
				if (coupon && item.couponWallFlag == 2) {
					coupon.classList.add("use-up");
				}
			});
		}, 100);
	}
	submitDataLink() {
		let query = this.$route.query
		if (!cookie.get('location') && !(this.browser.usqxcx || this.browser.ulexcx)) {
			this.isShowPosPop = true
			return
		}
		if (this.isClick) {
			this.isClick = false;
		} else {
			return false;
		}
		let chainDetailUrl = `https://ustatic${process.env.VUE_APP_URI_ULECDNDOMAIN}/freshcdn/fresh/act/queryXcxItemByActId/chainDetail/${this.good.activityCode}`;
		this.$http.jsonp(chainDetailUrl, {
			jsonp: "jsoncallback",
			jsonpCallback: "chainDetail",
		}).then((res: any) => {
			if (res.body.code == "0000") {
				setTimeout(() => {
					this.isClick = true;
				}, 500);
				let data = res.body.data
				let activitySource = '', helpSales = ''
				if (data.activitySource == 0 || data.activitySource == 1) {
					activitySource = data.activitySource;
				}
				if (data.helpSales == 0 || data.helpSales != 1) {
					helpSales = data.helpSales;
				}
				let url =
					`https://fresh-api${process.env.VUE_APP_URI_DOMAIN}/order/order/orderConfirm?ul_sch=${query.client_type || 'wap_ylxdsq'}&chainActivityFlag=${data.activityFlag}
					&shareId=${query.shareId || ''}&store_id=${query.store_id || ''}&itemInfo=${this.subList}&transport=${data.transport}
					&union_id=1016039300,1016039299&union_ref=${this.roomData.roomNumber + '_' + this.roomData.scene_number + ',' + this.good.activityCode}
					&selfSite=${data.selfSite}&listingType=104&freshActType=&activitySource=${activitySource}
					&helpSales=${helpSales}&siteId=${this.$route.query.siteId || ""}&orderType=1405&adid=${cookie.get('ul_adid') || ''}`
				console.log("提交订单的url=====", url);
				window.location.href = url;
			} else {
				this.isClick = true;
			}

		})
	}
	tocart() {
		this.$store.dispatch("environment/getYlxdsqCartAsync", true);
		this.viPageBack()
	}
	share() {
		this.$store.dispatch("environment/getIsShareAsync", true);
	}
	viPageBack() {
		this.$store.dispatch("environment/getIsGoodsDetailAsync", null);
	}
	onChangeBanner(index: number) {
		this.bannerCurrent = index;
	}
	checkedCoupon: boolean = false
	onCloseCoupon() {
		if (this.checkedCoupon) {
			//选择了七天不展示
			let _useronlyId = cookie.get('_useronlyId') || ''
			let couponShow=this.getCouponShow()
			let now = formatDate(new Date(), 'yyyy/MM/dd')
			couponShow[this.good.listId] = now
			localStorage.setItem(`couponShow${_useronlyId}`, JSON.stringify(couponShow))
			console.log('couponShow', couponShow)
		}
	}
	getCouponShow() {
		let _useronlyId = cookie.get('_useronlyId') || ''
		let showData = localStorage.getItem(`couponShow${_useronlyId}`)
		let couponShow: any = {}
		if (showData) {
			couponShow = JSON.parse(showData)
		}
		return couponShow
	}
	// 颜色切换
	changColor(index: any) {
		if (this.active == index) {
			return;
		} else {
			this.active = index;
		}
		if (this.minNum > 1) {
			this.prodCount = this.minNum;
		} else {
			this.prodCount = 1;
		}

		if (this.sizeActive >= this.goodsDetail.colors[index]["items"].length) {
			this.sizeActive = this.goodsDetail.colors[index]["items"].length - 1;
		}
	}
	// 规格切换
	changSize(index: any) {
		if (this.sizeActive == index) {
			return;
		} else {
			this.sizeActive = index;
			if (this.limit) {
				// 商品有限购
				if (Number(this.goodsDetail.limitNum) > Number(this.storage)) {
					// 限购数量超出库存时取最小
					this.goodsDetail.limitNum = this.storage;
				} else {
					// this.limitNum = limitNum
				}
			} else {
				if (Number(this.minNum) > Number(this.storage)) {
					// 最少购买数大于库存 ,团购商品存在这个问题
					this.$toast("商品已售罄");
					this.prodCount = this.storage;
				}
			}
		}
		if (Number(this.prodCount) > Number(this.storage)) {
			this.prodCount = this.storage;
		}
	}
	np = false
	ys = false
	prodCount = 1 //起购数量
	minNum = 1 //最小数量
	limit = false
	showCouponList: boolean = false
	couponPopTip: boolean = false
	getDetailData() {
		let url = `//ustatic${process.env.VUE_APP_URI_ULECDNDOMAIN}/freshcdn/item/detailFresh/detailFresh/${this.good.listId}/1.html`
		this.$http.jsonp(url, {
			jsonp: "jsonpCallback",
			jsonpCallback: "detailFresh",
		}).then((res: any) => {
			if (res.body.returnCode == '0000') {
				let data = res.body.data;
				this.goodsDetail = data
				this.goodsDetail.activityCode = this.good.activityCode
				this.getGoodsDetail()
				//查询券后价
				this.getCouponPrice(this.good.listId)
				this.paramsDesc = data.standardAttributeList ? JSON.parse(data.standardAttributeList) : [];
				// 判断是否是农品
				if (this.goodsDetail.listingTag && ~this.goodsDetail.listingTag.indexOf("1688")) {
					this.np = true;
				}
				// 判断是否是预售
				if (this.goodsDetail.listingTag && ~this.goodsDetail.listingTag.indexOf("1662")) {
					this.ys = true;
				}
				if (this.goodsDetail.limitWay == 0 || this.goodsDetail.limitWay > 7) {
					// 不限购
					this.prodCount = 1;
					this.minNum = this.goodsDetail.limitNum;
				} else if (this.goodsDetail.limitWay == 4) {
					// 起售
					this.minNum = this.goodsDetail.limitNum;
				} else if (this.goodsDetail.limitWay == 6) {
					this.limit = true;
				}
				let pslUrl = `https://m${process.env.VUE_APP_URI_DOMAIN}/itemAssist/item/psl.do?listId=${this.good.listId}`
				this.$http.jsonp(pslUrl, {
					jsonp: "jsonCallback",
					jsonCallback: "detailPsl",
				}).then((results: any) => {
					if (results.body.code == '0000') {
						let showIndex = -1, showSIndex = -1;
						data.colors.map((item: any, index: any) => {
							item.items.map((sItem: any, sindex: any) => {
								if (results.body.data) {
									results.body.data.item.forEach((el: any) => {
										if (el.itemId == sItem.itemId) {
											sItem.itemStorage = el.itemStorage;
											sItem.itemSalPrice = el.salePrice;
											if (showIndex == -1 && sItem.itemStorage > 0) {
												showIndex = index;
												showSIndex = sindex;
											}
										}
									});
								}
								if (sItem.itemId == data.defItemId && sItem.itemStorage > 0) {
									this.active = index;
									this.sizeActive = sindex;
								}
							});
						});
						if (this.storage <= 0 && showIndex > -1) {
							this.active = showIndex;
							this.sizeActive = showSIndex;
						}
					}

				})

				// 判断优惠券类型是否存在
				if (this.goodsDetail.listingTag) {
					if (
						this.goodsDetail.listingTag.indexOf("1705") > -1 ||
						this.goodsDetail.listingTag.indexOf("1706") > -1
					) {
						this.activeListingTag = this.goodsDetail.listingTag;
					}
				}
				if (this.goodsDetail.promotionIds.indexOf("6202") == -1 && this.goodsDetail.promotionIds.indexOf("6203") == -1) {
					//限时特价  新人礼特价  不支持优惠券
					let url = `//api${process.env.VUE_APP_URI_DOMAIN}/ylxditem/fresh/coupon/queryCanReceiveCoupon.do?storeId=${this.goodsDetail.uleStoreId}&itemId=${this.goodsDetail.defItemId}&businessType=4&listingTag=${this.activeListingTag}`
					this.$http.jsonp(url, {
						jsonp: "jsonCallback",
						jsonCallback: "jsonCallback",
					})
						.then((obj: any) => {
							let res = obj.body;
							let data = [];
							if ((res.returnCode == "0000" || res.code == "0000") && res.data) {
								data = res.data;
							}
							let arr: any[] = [];
							console.log("优惠券数据", data, res);
							data.map((item: any) => {
								let newObj = {
									available: 1,
									id: "", //优惠券 id
									name: "", // 优惠券名称
									condition: "", // 满减条件
									description: "",
									reason: "", // 不可用原因
									value: 0, // 折扣券优惠金额，单位分
									startAt: null,
									endAt: null,
									valueDesc: "", // 折扣券优惠金额文案
									unitDesc: "元", // 单位文案
									couponWallFlag: null
								};
								switch (item.couponType) {
									case "1":
										item.type = "店铺券";
										break;
									case "2":
										item.type = "商品券";
										break;
									case "3":
										item.type = "运费券";
										break;
									case "4":
										item.type = "充值券";
										break;
									case "5":
										item.type = "通用券";
										break;
									case "6":
										item.type = "品类券";
										break;
									case "7":
										item.type = "跨店券";
										break;
									default:
										item.type = "商品券";
								}
								if (item.isMultiStore == "true") {
									item.type = "跨店券";
								}
								newObj.id = item.batchId;
								newObj.name = item.remark || "优惠券名称";
								// 添加新活动判断
								if (
									this.goodsDetail.listingTag == null ||
									this.goodsDetail.listingTag == ""
								) {
									newObj.condition =
										item.fullCutAmount == 0
											? item.amount + "元,不限金额使用"
											: "满" + item.fullCutAmount + "减" + item.amount;
									item.desc =
										item.fullCutAmount == 0
											? "不限金额使用"
											: "满" + item.fullCutAmount + "减" + item.amount;
								} else {
									if (
										this.goodsDetail.listingTag.indexOf("1705") > -1 ||
										this.goodsDetail.listingTag.indexOf("1706") > -1
									) {
										if (item.couponType == "7") {
											newObj.condition =
												item.fullCutAmount == 0
													? item.amount + "元,全站不限金额使用"
													: "全站满" +
													item.fullCutAmount +
													"减" +
													item.amount;
											item.desc =
												item.fullCutAmount == 0
													? "全站不限金额使用"
													: "全站满" +
													item.fullCutAmount +
													"减" +
													item.amount;
										} else {
											newObj.condition =
												item.fullCutAmount == 0
													? item.amount + "元,不限金额使用"
													: "满" + item.fullCutAmount + "减" + item.amount;
											item.desc =
												item.fullCutAmount == 0
													? "不限金额使用"
													: "满" + item.fullCutAmount + "减" + item.amount;
										}
									} else {
										newObj.condition =
											item.fullCutAmount == 0
												? item.amount + "元,不限金额使用"
												: "满" + item.fullCutAmount + "减" + item.amount;
										item.desc =
											item.fullCutAmount == 0
												? "不限金额使用"
												: "满" + item.fullCutAmount + "减" + item.amount;
									}
								}
								newObj.description = item.type;
								newObj.reason = "";
								newObj.value = item.amount * 100;
								//将开始时间、结束时间转换为秒级时间戳
								// newObj.startAt = this.$moment(item.expireBeginDate).format(
								// 	"X"
								// );
								// newObj.endAt = this.$moment(item.expireEndDate).format("X");
								newObj.valueDesc = item.amount;
								newObj.couponWallFlag = item.couponWallFlag;
								item.couponName = item.type;
								arr.push(newObj);
							});
							this.oldCouObj = data;
							this.coupons = arr;
							this.allCoupons = [...this.coupons, ...this.disabledCoupons];
							//判断当前是否设置了七天内不再弹出优惠券，设置了且在七天时间内则不弹优惠券，没设置直接弹出优惠券
							let couponShow=this.getCouponShow()
							if(couponShow[this.good.listId]){
								console.log("优惠券不展示存储天数",getPreciseDayInterval(couponShow[this.good.listId],formatDate(new Date(), 'yyyy/MM/dd')))
								let dateDiff=getPreciseDayInterval(couponShow[this.good.listId],formatDate(new Date(), 'yyyy/MM/dd'))
								if(dateDiff && dateDiff>7){
									//优惠券不展示数据已过期，展示优惠券
									this.showCouponList = true;
									this.couponPopTip = true;
								}else{
									//不展示优惠券
									this.showCouponList = false;
									this.couponPopTip = false;
								}
							}else{
								//没有存储则直接弹出优惠券
								if (this.coupons.length > 0) {
									this.showCouponList = true;
									this.couponPopTip = true;
								} else {
									this.showCouponList = false;
									this.couponPopTip = false;
								}
							}
							console.log("this.coupons", this.coupons)
						})
						.then(() => {
							this.coupons.map(function (item: any, index: any) {
								let coupon = document.querySelectorAll(".van-coupon")[index];
								if (coupon && item.couponWallFlag == 2) {
									coupon.classList.add("use-up");
								}
							});
						});
				}

			}

		})
	}
	//查询券后价
	getCouponPrice(listIds:any){
		let goodsDetailUrl = `https://ustatic${process.env.VUE_APP_URI_ULECDNDOMAIN}/mobileactcdn/item/itemsRealInfo/getPrice/${listIds}`;
		this.$http.jsonp(goodsDetailUrl, {
			jsonp: "getPrice",
			jsonpCallback: "getPrice",
		}).then((res: any) => {
			console.log("券后价",res)
			if(res.body.code=='0000'){
				this.couponPrice = res.body.data[0].predictPrice;
			}

		})
	}
	getGoodsDetail() {
		let goodsDetailUrl = `https://ustatic${process.env.VUE_APP_URI_ULECDNDOMAIN}/mobilead/v2/item/getItemDetail/goodsDetail/${this.good.listId}.html`;
		this.$http.jsonp(goodsDetailUrl, {
			jsonp: "jsoncallback",
			jsonpCallback: "goodsDetail",
		}).then((results: any) => {
			if (results.body.returnCode == '0000' && results.body.data) {
				this.goodsDesc = results.body.data.replace(/src/g, "load-src").replace(/data-original/g, "src");
			}

		})
	}
	mounted() {
		this.getDetailData();
		let query = this.$route.query
		_com.getPosition(query, (res: any) => {
			if (res) {
				console.log(JSON.stringify(res))
			} else {
				console.log('定位成功')
			}
		})
	}

}

